/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogContent } from "@mui/material";
import { closeUserModal } from "../../Store/Slices/userSlice";
import AddUser from "./AddUser";
import DeleteUser from "./DeleteUser";
import EditUser from "./EditUser";

const UserDialog = () => {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    let content;
    let deleteView = false

    const roles = sessionStorage.getItem("roles");

    const handleClose = () => {
      dispatch(closeUserModal(false))
    }

    if (user.modalStatus === "add") {
      content = roles?.split(",").includes("PRIV_ES_ADD_USER") ? <AddUser handleClose={() => handleClose()}/> : null;
    } else if (user.modalStatus === "edit") {
      content = roles?.split(",").includes("PRIV_ES_EDIT_USER") ? <EditUser handleClose={() => handleClose()}/> : null;
    } else if (user.modalStatus === "delete") {
      deleteView = true
      content = roles?.split(",").includes("PRIV_ES_DELETE_USER") ? <DeleteUser/> : null;
    }

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={ deleteView ? "xs" : "md" }
                open={user.modalStatus === "add" || user.modalStatus === "edit" || user.modalStatus === "delete"}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>{content}</DialogContent>
            </Dialog>
        </>
    );
};

export default UserDialog
